import React, { FC } from 'react'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'
import GiveawayHero from '../Hero/GiveawayHero'
import { LearnMoreButton } from '../Hero/LearnMoreButton'
import { BackgroundLinearGradient } from './BackgroundLinearGradient'
import { BackgroundVideo } from './BackgroundVideo'
import { GiveawayNav } from './index'

export const GiveawayHeader: FC = () => {
  const {
    sweepstake,
    isBackgroundVideoPaused,
    togglePauseBackgroundVideo,
    scrollToProducts,
    isActive,
    phase,
    theatricalSlug,
    giveawayData,
    heroContainerRef,
    backgroundVideoUrl,
  } = useGiveawayContext()
  const {
    projectName,
    heroDesktopImageUrl,
    heroMobileImageUrl,
    trailerYoutubeId,
    giveawayYoutubeId,
    winnerAnnouncedDate,
  } = sweepstake

  const { inTheatersText, heroTitle } = giveawayData
  const { t } = useTranslate('tickets')

  const videoButtonText = giveawayYoutubeId
    ? t('watchGiveawayHeroVideo', 'Watch Giveaway Video')
    : t('watchVideo', 'Watch Video')

  return (
    <header
      ref={heroContainerRef}
      className="relative flex min-h-dvh flex-col bg-black p-6 md:h-[856px] md:min-h-full md:bg-center"
    >
      {heroDesktopImageUrl && heroMobileImageUrl && (
        <ResponsiveBackgroundImage
          srcUrls={{
            xs: heroMobileImageUrl,
            sm: heroMobileImageUrl,
            md: heroDesktopImageUrl,
            lg: heroDesktopImageUrl,
            xl: heroDesktopImageUrl,
            '2xl': heroDesktopImageUrl,
          }}
          src={heroMobileImageUrl}
        />
      )}

      <BackgroundLinearGradient />

      {backgroundVideoUrl && (
        <BackgroundVideo
          paused={isBackgroundVideoPaused}
          theatricalSlug={theatricalSlug}
          videoSrc={backgroundVideoUrl}
        />
      )}

      <GiveawayNav />

      <GiveawayHero
        isActive={isActive}
        phase={phase}
        theatricalSlug={theatricalSlug}
        inTheatersText={inTheatersText}
        projectName={projectName}
        trailerId={giveawayYoutubeId ?? trailerYoutubeId}
        title={heroTitle}
        winnerAnnouncedDate={winnerAnnouncedDate}
        onScrollToProducts={scrollToProducts}
        togglePauseBackgroundVideo={togglePauseBackgroundVideo}
        videoButtonText={videoButtonText}
      />

      <LearnMoreButton onClick={scrollToProducts} className="!font-compactaCom relative z-10 mx-auto mt-auto hidden" />
    </header>
  )
}
